'use client'

import React, { useEffect } from 'react'
import Image from 'next/image'
import { ModalDesktop, ModalMobile } from '@acko-tech/building-blocks.ui.modal'
import styles from './callback.module.scss'

export interface CallbackModalSchema {
  heading: string
  iconUrl: string
  submitCta: string
  description: React.ReactNode | string
  permittedUsers?: string[]
}

interface CallbackModalProps {
  isOpen: boolean
  isMobile: boolean
  onClose: () => void
  modalSchema: CallbackModalSchema
}

const CallbackModal: React.FC<CallbackModalProps> = ({ isOpen, isMobile, onClose, modalSchema }) => {
  useEffect(() => {
    document.documentElement.style.overflowY = isOpen ? 'hidden' : 'scroll'
  }, [isOpen])

  const modalContent = (
    <div className={styles.callbackModalContent}>
      <div className={styles.callbackModalIcon}>
        <Image src={modalSchema.iconUrl} alt="Success" width={116} height={90} />
      </div>
      <h3 className={styles.callbackModalHeading}>{modalSchema.heading}</h3>
      <p className={styles.callbackModalDescription}>{modalSchema.description}</p>
      <button className={styles.callbackModalCta} onClick={onClose} type="button">
        {modalSchema.submitCta}
      </button>
    </div>
  )

  return isMobile ? (
    <ModalMobile
      align="left"
      show={isOpen}
      onHide={onClose}
      padding="0px"
      urlhash=""
      showOverlayBackground
      disableOverlayClose={false}
      bodyMargin="0px"
      wrapperStyles={{
        borderRadius: '24px 24px 0 0',
      }}
      closeButtonStyles={{
        right: '8px',
        top: '12px',
        width: '32px',
        height: '32px',
        maxWidth: '32px !important',
        maxHeight: '32px !important',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '8px',
        zIndex: '9999',
        position: 'absolute',
      }}>
      {modalContent}
    </ModalMobile>
  ) : (
    <ModalDesktop
      align="right"
      show={isOpen}
      onHide={onClose}
      padding="0px"
      urlhash=""
      disableOverlayClose={false}
      styles={{
        width: '540px',
        borderRadius: '40px',
        overflow: 'hidden',
        boxShadow: '0 8px 24px rgba(0, 0, 0, 0.15)',
        maxWidth: '540px',
        ':nth-child(2)': {
          marginTop: '0px',
        },
      }}
      closeButtonStyles={{
        right: '32px',
        top: '16px',
        padding: '4px',
      }}>
      {modalContent}
    </ModalDesktop>
  )
}

export default CallbackModal
